import React from 'react';
import { get } from 'lodash';
import { SPI_METRIC } from '@components/top-widget-panel/spi-panel/widgets/constants';
import humanizeUtil from '@utils/humanizeUtil';
import { getMetricUnitByKey } from '@utils/metrics';
import { calculatePctShare } from '@utils/table/pctShare';
import { StyledCell } from './styled';
import { getPrimaryKeyFromPercentageLocalKey } from '@src/utils/metrics/metricHelpers';
import { getTextColor } from '@src/utils/kpi/tools';
import { useAtomValue } from 'jotai';
import { blueBarAtom } from '@src/components/ActionToolbar/atoms';
import DoDTrend from './DoDTrend';
// TODO: humanize in utils

function ValueCell({ cellData, column, container, rowData }) {
  const showBlueBar = useAtomValue(blueBarAtom);

  if (['NA', 'low'].includes(cellData)) {
    return (
      <StyledCell>
        <span>{cellData}</span>
      </StyledCell>
    );
  }
  const textStyle: any = { flex: 1 };
  let classStr = '';

  const { metric } = column;

  if (!column.colorless && metric === SPI_METRIC) {
    textStyle.color = getTextColor(cellData);
    textStyle.fontWeight = 600;
    classStr = 'color-critical';
  }

  const unit =
    column.mfPctChecked || !!getPrimaryKeyFromPercentageLocalKey({ metricKey: column.metric })
      ? '%'
      : getMetricUnitByKey({ metricKey: metric });
  const { humanizedNumber, humanizedUnit } = humanizeUtil(cellData, metric, unit as string);

  // relative cell share to max value
  const pctShare =
    rowData.hidePctShare || !showBlueBar
      ? 0
      : calculatePctShare({
          value: cellData,
          pctShareMaxValue: get(
            container,
            ['props', 'headerProps', 'pctShareMaxValues', column.dataKey],
            0,
          ),
        });

  const showTrend = get(container, ['props', 'headerProps', 'showTrend'], false);

  return (
    <StyledCell pctShare={pctShare} $showTrend={showTrend}>
      <div style={textStyle} className={classStr}>
        {`${humanizedNumber} ${humanizedUnit}`}
      </div>
      {showTrend && <DoDTrend rowData={rowData} cellData={cellData} unit={unit} column={column} />}
    </StyledCell>
  );
}

export default React.memo(ValueCell);
